import { useProductContext } from "../context"

export const ProductSlogan = () => {
  const { slogan } = useProductContext()

  if (!slogan) {
    return null
  }

  return <h2 className="text-np-green m-0 w-full text-xl font-medium">{slogan}</h2>
}
